import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f6f7fb]">
        <Loader2 className="w-6 h-6 animate-spin text-indigo-500" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  // Portal-only / engineer-only accounts have no web-admin access.
  const hasWebAccess = user.is_super || (user.permissions || []).includes("dashboard.view");
  if (!hasWebAccess) {
    if ((user.roles || []).includes("customer")) {
      return <Navigate to="/portal/demo" replace />;
    }
    return <EngineerBlocked />;
  }
  return children;
}

function EngineerBlocked() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f6f7fb] p-6" data-testid="engineer-blocked">
      <div className="text-center max-w-md">
        <h1 className="text-2xl font-bold text-slate-900">Engineer app access</h1>
        <p className="text-sm text-slate-500 mt-2">
          Your account is set up for the field engineer app and does not have access to the
          web administration system. The engineer app is a separate, upcoming release.
        </p>
      </div>
    </div>
  );
}
